import { gql, useQuery } from '@apollo/client';

export const GET_EMPLOYEE_DOCUMENTS = gql`
  query getMemberById($memberId: ObjectId!) {
    getMemberById(memberId: $memberId) {
      documents {
        _id
        documentLabelId
        documentLabel {
          _id
          name
        }
        documentTemplatesIds
        documentTemplates {
          _id
          title
          file {
            location
          }
        }
      }
    }
  }
`;

export const useGetEmployeeDocuments = (id: string) => {
  const { data, loading } = useQuery(GET_EMPLOYEE_DOCUMENTS, {
    variables: { memberId: id },
    skip: !id,
    fetchPolicy: 'network-only',
  });

  const documents = data?.getMemberById?.documents || [];

  return { documents, loading };
};
